import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import greenCheckUrl from '@Assets/icons/ic-green-check.svg';
import greyXUrl from '@Assets/icons/ic-grey-x.svg';

const REQUIRED_ITEM_KEYS = [
  'mainContent.requiredItems.passport',
  'mainContent.requiredItems.smartphone',
  'mainContent.requiredItems.livePhoto',
] as const;

export const DocVRequirementsList = () => {
  const { t } = useTranslation('nonUsSocure');

  return (
    <div className='flex flex-col gap-[8px]'>
      <Text.H10 className='text-text-main-secondary'>{t('mainContent.youWillNeed')}</Text.H10>

      <ul className='flex flex-col gap-[4px]'>
        {REQUIRED_ITEM_KEYS.map((key) => (
          <li key={key} className='flex w-full items-start gap-[4px]'>
            <img src={greenCheckUrl} alt='' className='h-[20px] w-[20px] shrink-0' />
            <Text.H10 className='text-text-main-secondary'>{t(key)}</Text.H10>
          </li>
        ))}

        <li className='flex w-full items-start gap-[4px]'>
          <img src={greyXUrl} alt='' className='h-[20px] w-[20px] shrink-0' />
          <Text.H10 className='text-text-main-secondary'>
            {t('mainContent.requiredItems.screenshots')}
          </Text.H10>
        </li>
      </ul>
    </div>
  );
};
